import { customAlphabet } from "nanoid";

export const getRandomString = customAlphabet(
  "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
);
